<template>
  <span v-html="sanitizedHtml"></span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { sanitizeHighlightedText } from '@/utils/safeHighlighting'

interface Props {
  text: string
}

const props = defineProps<Props>()

const sanitizedHtml = computed(() => {
  return sanitizeHighlightedText(props.text)
})
</script>

<style>
/* Global search highlight styles - no conflicts with other .highlight classes */
.search-highlight,
em.search-highlight {
  background-color: var(--yellow-100, #fef3c7);
  font-style: normal; /* Override default <em> italic styling */
  padding: 0;
  text-decoration: none;
}

/* Prevent link text-decoration from cascading to search highlights */
a .search-highlight,
a em.search-highlight {
  text-decoration: none;
  background-color: var(--yellow-100, #fef3c7) !important;
  color: inherit;
}
</style>

